<template>
  <v-alert
  :type="alertType"
  class="text-white">
    {{ text }}
  </v-alert>
</template>

<script>
export default {
  name: 'ColouredValueBool,',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: 'You are required to complete this',
    },
  },
  computed: {
    isSuccess() {
      return this.value === true;
    },
    isError() {
      return this.value === false;
    },
    alertType() {
      if (this.isSuccess) {
        return 'success';
      }
      return 'error';
    },
  },
};
</script>
<style scoped>
.text-success {
  color: green;
}
.text-error {
  color: red;
}
</style>
